/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import { injectIntl } from 'react-intl';
import axios from 'axios';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl } from '../../../../_metronic/_helpers';
import { Button } from '../../../components/Button';
import { Drawer } from '../../../components/Drawer';
import { TextArea } from '../../../components/TextAreaInput';
import { TextField } from '../../../components/TextFieldInput';
import { UploadFile } from '../../../components/UploadFile';
import RemoveDialog from '../../../components/RemoveDialog';
import { SelectInput } from '../../../components/SelectInput';

const LABEL_SIZE = 80;

function EditFloorPlanSideMenu({
  open,
  onClose,
  floorPlan,
  intl,
  formik,
  onDrop,
  onDelete,
  hasPermission,
  addScale,
}) {
  const [openModel, setOpen] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [processingGroups, setProcessingGroups] = useState([]);

  useEffect(() => {
    async function getProcessingGroups() {
      const { data } = await axios.get('/processing-groups');
      if (data) {
        data.forEach(x => (x.description = x.groupName));
        data.unshift({
          description: intl.formatMessage({ id: 'NONE' }),
          groupId: '',
        });
        setProcessingGroups(data);
      }
    }
    getProcessingGroups();
  }, []);

  function afterClear() {
    formik.setFieldValue('floorPlanURI', floorPlan.floorPlanURI);
  }

  function closeModal() {
    setOpen(false);
  }

  function editScale() {
    addScale();
    onClose();
  }

  return (
    <Drawer onClose={onClose} containerId="floor-plan-container" open={open}>
      <div className="h-100" style={{ width: 400 }}>
        <div className="d-flex flex-column px-0 h-100">
          <div className="card-header d-flex justify-content-between card-header-bg flex-0">
            <div className="d-flex align-items-center">
              <span className="svg-icon mr-2">
                <SVG
                  cacheRequests
                  uniquifyIDs
                  src={toAbsoluteUrl('/media/svg/senseworks/floormap.svg')}
                />
              </span>
              <div className="ml-2">
                <h4 className="m-0 title">
                  {' '}
                  {intl.formatMessage(
                    { id: 'NAME_VALUE' },
                    { name: get(formik, 'values.name', ' ') }
                  )}{' '}
                </h4>
                <span className="sub-title">
                  {' '}
                  {intl.formatMessage({
                    id: 'AREAS.FACILITIES.FLOORPLANS.EDIT.MENU.SUBTITLE',
                  })}{' '}
                </span>
              </div>
            </div>
          </div>
          <div className="card-body flex-grow-1 overflow-auto">
            <div className="col-12 px-0">
              <TextField
                field="externalId"
                inputSize="100%"
                labelMinSize={LABEL_SIZE}
                formik={formik}
                label="ID"
              />
            </div>
            <div className="col-12 px-0">
              <TextField
                field="name"
                inputSize="100%"
                labelMinSize={LABEL_SIZE}
                formik={formik}
                label={intl.formatMessage({
                  id: 'AREAS.FACILITIES.FLOORPLANS.NEW.NAME',
                })}
              />
            </div>
            <div className="col-12 px-0">
              <TextArea
                direction="align-items-center"
                field="description"
                inputSize="100%"
                labelMinSize={LABEL_SIZE}
                formik={formik}
                label={intl.formatMessage({ id: 'DESCRIPTION' })}
              />
            </div>
            <div className="col-12 px-0">
              <SelectInput
                classes="d-block w-100"
                field="processingGroupId"
                options={processingGroups}
                label={intl.formatMessage({ id: 'PROCESSING_GROUP' })}
                formik={formik}
                value="groupId"
              />
            </div>
            <div className="col-12 px-0 d-flex align-items-center mb-6">
              <div style={{ minWidth: LABEL_SIZE }}>
                <span> {intl.formatMessage({ id: 'SCALE' })} </span>
              </div>
              <Button
                classes="cancel-bg cancel-btn cancel-text-color px-4"
                type="button"
                onClick={editScale}
                title={intl.formatMessage({ id: 'SET_SCALE' })}
              />
            </div>
            <div className="form-group">
              <div style={{ marginLeft: LABEL_SIZE }}>
                <UploadFile
                  send={onDrop}
                  afterClear={afterClear}
                  setUploading={setIsUploading}
                />
                {formik.errors['floorPlanURI'] ? (
                  <div className="d-flex">
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors['floorPlanURI']}
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between flex-0 p-4 border-top-gainsboro">
            <div className="d-flex">
              {hasPermission('floor-plans*', 'U') && (
                <Button
                  classes="w-75px px-12 py-2 my-1 d-flex align-items-center justify-content-center btn btn-primary"
                  disabled={isUploading}
                  type="submit"
                  formik={formik}
                  onClick={formik.handleSubmit}
                  title={intl.formatMessage({ id: 'SAVE' })}
                />
              )}
              <Button
                classes="w-75px cancel-bg ml-3 cancel-btn cancel-text-color px-4"
                type="button"
                onClick={onClose}
                title={intl.formatMessage({ id: 'CANCEL' })}
              />
            </div>
            <div>
              {hasPermission('floor-plans*', 'U') && (
                <Button
                  classes="w-75px bg-danger ml-3 px-4"
                  type="button"
                  onClick={() => setOpen(true)}
                  title={intl.formatMessage({ id: 'DELETE' })}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {hasPermission('floor-plans*', 'D') && (
        <RemoveDialog
          open={openModel}
          onCancel={closeModal}
          onClose={closeModal}
          onConfirm={() => {
            setOpen(false);
            onDelete();
          }}
          name={floorPlan.name}
          title="ACTIONS.REMOVE.FLOOR_PLAN.TITLE"
          message="ACTIONS.REMOVE.FLOOR_PLAN.BODY"
        />
      )}
    </Drawer>
  );
}

export default injectIntl(EditFloorPlanSideMenu);
